<template>
  <div id="app">
    <UserLogin v-if="!isShowIframe"></UserLogin>
    <IframeComponent v-else/>
  </div>
</template>

<script>
import IframeComponent from './components/IframeComponent.vue';
import Message from '@/mixins/Message';
import platform from 'platform';
import {txGetRequest} from "@/plugins/request";
import {globalStorage} from "@/util/tool";
import UserLogin from './components/UserLogin.vue';
export default {
  name: 'App',
  mixins: [Message],
  components: {
    IframeComponent,
    UserLogin
  },
  data() {
    return {
      url:'',
      game_id:'',
      qudao_id:''
    };
  },
  methods:{
    async getConfigSet(){
      let {code,message,data} =await txGetRequest(`/game/settings/${this.qudao_id}/${this.game_id}`)
      if (code!==0){
        return this.errorMessage(message)
      }
      globalStorage.set('updateSdkConfig',data)
      let os = platform.os.family || 'Unknown';
      os=os.toLowerCase()
      let device='pc'
      if (os==='ios'||os==='android'){
        device=platform.product
      }
      globalStorage.set('updateReportParams', {game_id:this.game_id,qudao_id:0,qudao_uid:"0",os,device,ip:"127.0.0.1"})
    }
  },
  computed: {
    isShowIframe() {
      return globalStorage.get_value('getUserParams','isShowIframe')
    }
  },
  mounted() {
    document.title = 'tx';
  },
  created() {
    //判断是否为微信环境
    let query=this.$route.query
    let game_id=75023858
    let qudao_id = 3
    if (!game_id){
      return this.errorMessage('game_id不正确')
    }
    globalStorage.set('updateUserParams', {game_id:game_id})
    this.game_id=game_id
    this.qudao_id = qudao_id
    if (window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
      //如果携带了code 说明是微信环境已经是回调环境了
      if (!query.code){
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd2c1bcdfa5518b37&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      }
    }
    this.getConfigSet()
  }
}
</script>

<style>
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*margin-top: 60px;*/
  height: 100%;
  color: #000;
  background-color: #0009;
  font-family: 'Roboto', sans-serif;
}
html,body{
  height: 100%;
  overflow-y: hidden;
  margin: 0;
  padding-right:0 !important;
  font-family: 'Roboto', sans-serif;
}
.el-button,
.el-dialog {
    font-family: 'Roboto', sans-serif;
}
</style>
